import keycloak from '../../../auth/keycloak';

export default error => {
  keycloak.login();
  return Promise.reject(error);
};
